import { useTranslation } from "react-i18next";
import MainApiService from "./../../../services/mainApi.service";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import { Chip } from "@mui/material";
import { IAutomationRulesMarCom } from "../../../models/automation-rule-marcom";
import { useNavigate } from "react-router-dom";

const AUTOMATION_RULE_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/MarComAutomationRule/";
const marComAutomationRuleService = new MainApiService<IAutomationRulesMarCom>(
  AUTOMATION_RULE_ROUTE,
);

const translationPath = "page.4uMarCom.automationRules.";

const AutomationRulesMarComPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const columns: GridColDef<IAutomationRulesMarCom>[] = [
    {
      field: "name",
      headerName: t(translationPath + "name") || "Name",
    },
    {
      field: "createdByUserName",
      headerName: t(translationPath + "created_by") || "Created By",
      renderCell: (params) =>
        params.value ? (
          <OverflowTooltip
            text={params.value}
            tooltip={params.value}
            textTransform="none"
            variant="body2"
          />
        ) : (
          "-"
        ),
    },
    {
      field: "enable",
      headerName: t(translationPath + "status") || "Status",
      renderCell: ({ row: { enable } }) => {
        return (
          <Chip
            label={
              enable
                ? t(translationPath + "active")
                : t(translationPath + "inactive")
            }
            color={enable ? "success" : "error"}
          />
        );
      },
    },
  ];
  const handleAdd = () => {
    navigate("new");
  };

  const handleRowClick = (params: GridRowParams<IAutomationRulesMarCom>) => {
    navigate(`${params.id.toString()}/edit`);
  };

  return (
    <Table<IAutomationRulesMarCom>
      showDefaultMacroFilters={false}
      service={marComAutomationRuleService}
      columns={columns}
      title={t(translationPath + "title")}
      searchInput
      onAdd={handleAdd}
      onRowClick={handleRowClick}
      searchInputPlaceHolder={
        t(translationPath + "search") || "Search for a automation rule"
      }
      addButtonLabel={t(translationPath + "add") || "Add Automation Rule"}
      confirmOptions={{
        title: t(translationPath + "confirm.title"),
        description: t(translationPath + "confirm.description"),
        confirmationButtonProps: {
          variant: "contained",
        },
      }}
    />
  );
};

export default AutomationRulesMarComPage;
